import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import clsx from 'clsx';

import { getNormalizeText } from '@utils/getNormalizeText';

import css from './CookiesModal.module.scss';

const cookiesContent = {
  head: {
    title: 'We Use Cookies',
    description:
      'We use cookies for essential site functions and analytics. Choose which ones you’re comfortable with.',
  },
  buttons: {
    all: 'Accept All',
    necessary: 'Accept Necessary',
    save: 'Save Preferences',
  },
  settings: [
    {
      id: 'necessary',
      title: 'Necessary',
      description: 'Enables security and basic functionality',
      disabled: true,
      checked: true,
    },
    {
      id: 'preferences',
      title: 'Preferences',
      description: 'Enables personalized content and settings',
      disabled: false,
      checked: false,
    },
    {
      id: 'analytics',
      title: 'Analytics',
      description: 'Enables tracking of performance',
      disabled: false,
      checked: false,
    },
    {
      id: 'marketing',
      title: 'Marketing',
      description: 'Enables ads personalization and tracking',
      disabled: false,
      checked: false,
    },
  ],
};

const CookiesModal = () => {
  const { head, buttons, settings } = cookiesContent;

  const [isOpen, setIsOpen] = useState(false);
  const [showSettings, setShowSettings] = useState(false);

  // Ініціалізуємо prefs з settings (checked + disabled)
  const initialPrefs = Object.fromEntries(settings.map(s => [s.id, s.checked]));
  const [prefs, setPrefs] = useState(initialPrefs);

  // Показуємо модалку, якщо куки ще не встановлені
  useEffect(() => {
    const saved = Cookies.get('user_riib_cookies');
    if (saved) return;

    const timer = setTimeout(() => setIsOpen(true), 500);
    return () => clearTimeout(timer);
  }, []);

  // Прийняти всі
  const handleAcceptAll = () => {
    const allPrefs = Object.fromEntries(settings.map(s => [s.id, true]));
    Cookies.set('user_riib_cookies', JSON.stringify(allPrefs), {
      expires: 365,
    });
    setIsOpen(false);
  };

  // Відкрити налаштування
  const handleOpenSettings = () => setShowSettings(true);

  // Зміна чекбокса
  const handleCheckbox = (id, checked) => {
    setPrefs(prev => ({ ...prev, [id]: checked }));
  };

  // Зберегти вибір
  const handleSave = e => {
    e.preventDefault();
    Cookies.set('user_riib_cookies', JSON.stringify(prefs), { expires: 365 });
    setIsOpen(false);
  };

  return (
    <div className={clsx(css.cookies, isOpen && css.isOpened)}>
      <div className={css.cookies__body}>
        <div className={css.cookies__head}>
          <h5
            className={css.tl5}
            dangerouslySetInnerHTML={{ __html: getNormalizeText(head.title) }}
          />

          <div className={css.txt2}>
            <p
              dangerouslySetInnerHTML={{
                __html: getNormalizeText(head.description),
              }}
            />
          </div>
        </div>

        <div className={clsx(css.cookies__btns, !showSettings && css.isActive)}>
          <button
            type="button"
            className={clsx(css.btn, css.all)}
            onClick={handleAcceptAll}
          >
            {buttons.all}
          </button>

          <button
            type="button"
            className={clsx(css.btn, css.necess)}
            onClick={handleOpenSettings}
          >
            {buttons.necessary}
          </button>
        </div>

        <div className={clsx(css.cookies__sett, showSettings && css.isActive)}>
          <form className={css.cookies__form} onSubmit={handleSave}>
            {settings.map(({ id, title, description, disabled }) => (
              <div key={id} className={css.cookies__tuning}>
                <div className={css.cookies__box}>
                  <h6
                    dangerouslySetInnerHTML={{
                      __html: getNormalizeText(title),
                    }}
                  />
                  <p
                    dangerouslySetInnerHTML={{
                      __html: getNormalizeText(description),
                    }}
                  />
                </div>

                <label className={css.cookies__checkbox}>
                  <input
                    type="checkbox"
                    name={id}
                    checked={prefs[id]}
                    onChange={e =>
                      !disabled && handleCheckbox(id, e.target.checked)
                    }
                    disabled={disabled}
                  />
                  <span></span>
                </label>
              </div>
            ))}

            <button type="submit" className={css.btn}>
              {buttons.save}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CookiesModal;
